module.exports = __webpack_public_path__ + "img/icon_sheep_logo.3006b155.png";